var map = {
	"./BadalLogo-01.png": 257,
	"./Badal_by_TELUS_Business.png": 7007,
	"./bios/bio-1-about.png": 6364,
	"./bios/bio-1.png": 180,
	"./bios/bio-2-about.png": 1795,
	"./bios/bio-2.png": 1807,
	"./bios/bio-3-about.png": 2246,
	"./bios/bio-3.png": 8006,
	"./brands/Eyereturn Marketing Logo.png": 2913,
	"./brands/LD Logo.png": 4410,
	"./brands/atb.png": 32,
	"./brands/atbBW.png": 3341,
	"./brands/bmo.png": 2449,
	"./brands/bmoBW.png": 7992,
	"./brands/broker-bay.png": 1375,
	"./brands/broker-bayBW.png": 9974,
	"./brands/cameco-logo.png": 8831,
	"./brands/cameco.png": 2855,
	"./brands/camecoBW.png": 4814,
	"./brands/cibc.png": 6098,
	"./brands/cibcBW.png": 1359,
	"./brands/cogeco.png": 1479,
	"./brands/cogecoBW.png": 2798,
	"./brands/eye-return-marketing.png": 6966,
	"./brands/eye-return-marketingBW.png": 2555,
	"./brands/firstlight-media.png": 1038,
	"./brands/firstlight-mediaBW.png": 9235,
	"./brands/hamilton-health-science.png": 5857,
	"./brands/hamilton-health-scienceBW.png": 488,
	"./brands/keyera.png": 162,
	"./brands/keyeraBW.png": 6447,
	"./brands/pc-financial.png": 3790,
	"./brands/pc-financialBW.png": 2083,
	"./brands/scotiabank.png": 6104,
	"./brands/scotiabankBW.png": 4341,
	"./brands/telus.png": 9508,
	"./brands/telusBW.png": 7001,
	"./brands/therapia.png": 3703,
	"./brands/therapiaBW.png": 5646,
	"./brands/tmx.png": 7564,
	"./brands/tmxBW.png": 4945,
	"./brands/w-games.png": 7390,
	"./events/BadalNiagaraFallsJuly2022.jpg": 6931,
	"./events/BadalRecRoomApril2022.jpg": 7527,
	"./events/PaintNight.jpg": 6646,
	"./events/map.png": 8296,
	"./flavicon-03.png": 1724,
	"./left-Arrow.png": 2867,
	"./page-heroes/about-page-hero.png": 7147,
	"./page-heroes/blog-page-hero.png": 1736,
	"./page-heroes/blogs-page-hero.png": 2339,
	"./page-heroes/careers-page-hero.png": 8285,
	"./page-heroes/casestudy-page-hero.png": 4027,
	"./page-heroes/contact-page-hero.png": 6576,
	"./page-heroes/home-page-hero.png": 4793,
	"./page-heroes/services-page-hero.png": 6820,
	"./page-heroes/work-page-hero.png": 8599,
	"./pages/about/laptop.png": 2549,
	"./pages/home/how-we-make-the-cloud.png": 6279,
	"./partners/collibra.png": 1646,
	"./partners/collibraBW.png": 3939,
	"./partners/databricks.png": 856,
	"./partners/databricksBW.png": 3541,
	"./partners/gc-partners.png": 6366,
	"./partners/gc-partnersBW.png": 4051,
	"./partners/hashicorp.png": 5345,
	"./partners/looker.png": 3402,
	"./partners/lookerBW.png": 5671,
	"./partners/secoda.png": 2161,
	"./partners/secodaBW.png": 9224,
	"./right-Arrow.png": 3468,
	"./svgs/blue-swirl.svg": 9140,
	"./svgs/cameco-logo.svg": 3130,
	"./svgs/careers-color-block-1.svg": 3791,
	"./svgs/careers-color-block-2.svg": 2092,
	"./svgs/careers-color-block-3.svg": 1805,
	"./svgs/careers-color-block-4.svg": 3490,
	"./svgs/data-analytics-icon-strip/bigquery.svg": 3589,
	"./svgs/data-analytics-icon-strip/cloud_composer.svg": 335,
	"./svgs/data-analytics-icon-strip/dataflow.svg": 8615,
	"./svgs/data-analytics-icon-strip/looker.svg": 2835,
	"./svgs/data-analytics-icon-strip/pubsub.svg": 8266,
	"./svgs/facebook-footer.svg": 6762,
	"./svgs/facebook-sidebar.svg": 5825,
	"./svgs/flip-card-position-one.svg": 9765,
	"./svgs/flip-card-position-two.svg": 5467,
	"./svgs/home-hero-swirl.svg": 9658,
	"./svgs/icon-strip/cloud_load_balancing.svg": 9809,
	"./svgs/icon-strip/cloud_sql.svg": 4807,
	"./svgs/icon-strip/compute_engine.svg": 1339,
	"./svgs/icon-strip/error_reporting.svg": 8216,
	"./svgs/icon-strip/trace.svg": 3274,
	"./svgs/icon-strip/virtual_private_cloud.svg": 7778,
	"./svgs/linkedin-footer.svg": 5556,
	"./svgs/linkedin-sidebar.svg": 595,
	"./svgs/partners-bottom-swirl.svg": 1275,
	"./svgs/rounded-bottom-one.svg": 5240,
	"./svgs/rounded-bottom-two.svg": 9770,
	"./svgs/scotiabank-logo.svg": 3171,
	"./svgs/twitter-footer.svg": 7937,
	"./svgs/twitter-sidebar.svg": 7028,
	"./svgs/youtube-footer.svg": 6507,
	"./svgs/youtube-sidebar.svg": 9622,
	"./testimonials/jane-smith.png": 6083,
	"./testimonials/john-doe.png": 245,
	"./testimonials/max-power.png": 963
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;